import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'sp0003',
    ecrans: ['00-2'],
    params: ['id',
             '?tsecleint',
             '?demcleint']
});
